/**
 * Single Post Module
 *
 * Tombol "copy link" di rail share artikel. navigator.clipboard hanya
 * tersedia di secure context (https/localhost), jadi disiapkan fallback
 * lewat textarea + execCommand supaya tetap jalan di preview http.
 */

export function initSinglePost() {
  initShareCopyLink();
}

function initShareCopyLink() {
  const buttons = document.querySelectorAll(".single-post__share-copy");
  if (!buttons.length) return;

  buttons.forEach((button) => {
    button.addEventListener("click", async () => {
      const url = button.dataset.copyUrl || window.location.href;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
        } else {
          legacyCopy(url);
        }
        flagCopied(button);
      } catch (error) {
        // Diamkan: kegagalan copy tidak boleh menghentikan interaksi lain.
      }
    });
  });
}

function legacyCopy(text) {
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
}

function flagCopied(button) {
  button.classList.add("is-copied");
  window.setTimeout(() => {
    button.classList.remove("is-copied");
  }, 1800);
}
